module.exports = __webpack_public_path__ + "static/media/ivb.723c126d.svg";